import React from 'react';
import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';
import { Controller, useForm } from 'react-hook-form';
import { useAors } from 'hooks/useAors';

export default function ManageTeamLocation({ selectedAor, onChangeAor }) {
  const { data: aors = [], isLoading } = useAors();

  const { control } = useForm({ mode: 'onChange' });

  const aorOptions = aors.map((aor) => ({
    value: aor.id,
    label: aor.name,
  }));

  const selectedValue = selectedAor
    ? {
        value: selectedAor.id || selectedAor.aorId,
        label: selectedAor.name || selectedAor.aorName,
      }
    : null;

  return (
    <div className="manage-team-location">
      <div className="row mb-4">
        <label className="form-label">Area of Responsibility</label>
        <Controller
          control={control}
          name="aor"
          rules={{ required: true }}
          render={({ field: { _onChange, _value } }) => (
            <StylishNewSelect
              options={aorOptions}
              defaultValue={selectedValue}
              value={selectedValue}
              onChange={(e) =>
                onChangeAor({
                  aorId: e?.value,
                  aorName: e?.label,
                })
              }
              placeholder="Select Area of Responsibility"
              isClearable={true}
              isSearchable={true}
              isMulti={false}
              isDisabled={isLoading}
            />
          )}
        />
      </div>
    </div>
  );
}
